export default "__VITE_ASSET__B5XL0dZP__"